// StatusDot — semantic dot, optionally pulsing.

import { cn } from "@/lib/cn";

export type StatusTone = "ok" | "warn" | "error" | "info" | "default";

export interface StatusDotProps {
  tone?: StatusTone;
  pulse?: boolean;
  size?: number;
  className?: string;
  label?: string;
}

export function StatusDot({ tone = "ok", pulse, size = 8, className, label }: StatusDotProps) {
  return (
    <span
      className={cn("lex-status-dot", pulse && "lex-status-dot--pulse", className)}
      data-tone={tone}
      style={{ width: size, height: size }}
      aria-label={label}
      role={label ? "status" : undefined}
    />
  );
}

export default StatusDot;
